import * as React from "react";
import { IconButton, IconButtonProps, Tooltip, useTheme } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useModalStyles } from "./useModalStyles";
import { useNavigation } from "../../hooks/useNavigation";
import { tokens } from "../../theme";

interface PageBackButtonProps extends Omit<IconButtonProps, "onClick" | "size" | "children"> {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltip?: string | null;
}

const PageBackButton: React.FC<PageBackButtonProps> = ({ onClick, tooltip = "Go back", sx, ...rest }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { tokens: mTokens } = useModalStyles();
  const { navigate } = useNavigation();

  const button = (
    <IconButton
      aria-label="Back"
      onClick={onClick ?? (() => navigate(-1))}
      size="small"
      sx={{
        mt: 0.4,
        border: `1px solid ${mTokens.accent}`,
        borderRadius: "10px",
        width: 34,
        height: 34,
        color: mTokens.accent,
        backgroundColor: mTokens.bg,
        flexShrink: 0,
        "&:hover": { borderColor: colors.grey[300], color: colors.grey[300], backgroundColor: colors.grey[700] },
        ...sx,
      }}
      {...rest}
    >
      <ArrowBack sx={{ fontSize: "1.1rem" }} />
    </IconButton>
  );

  if (!tooltip) return button;

  return (
    <Tooltip title={tooltip} placement="bottom" arrow>
      {button}
    </Tooltip>
  );
};

export default PageBackButton;
